import { render, staticRenderFns } from "./DestinationCard.vue?vue&type=template&id=f16a06ae&"
import script from "./DestinationCard.vue?vue&type=script&lang=js&"
export * from "./DestinationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports